<template >
    <v-app>
        <v-container fluid>
            <v-row>
              <v-col v-if="moduleName && !isSmartDashboard && !isInventoryOrPurchaseDashboard" cols="12" class="text-center">
                <v-card variant="tonal" color="primary">
                  <v-card-text class="pa-1">
                    <p class="text-h6 text-primary mb-1">{{ moduleName }}</p>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col v-if="isSmartDashboard && currentComponent" cols="12" class="pa-0">
                <component :is="currentComponent" :module-key="normalizedDashboardModule" />
              </v-col>
              <v-col v-else-if="currentComponent">
                <component  :is="currentComponent" />
              </v-col>
            </v-row>
        </v-container>

    </v-app>
</template>

<script>

import breadCrumbs from '@/components/utils/breadCrumbs.vue';
import SaleDashboard from '@/components/module/sales/saleDashboard.vue';
import purchaseDashboard from '@/components/module/purchase/purchaseDashboard.vue';
import inventoryDashboard from '@/components/module/inventory/inventoryDashboard.vue';
import projectDashboard from '@/components/module/project/projectDashboard.vue';
import CustomerProfileWorkspace from "@/views/module/customerProfile/CustomerProfileWorkspace.vue";
import {defineAsyncComponent} from "vue";



export default {
    components: {
        SaleDashboard,
        purchaseDashboard,
        inventoryDashboard,
        projectDashboard,
        CustomerProfileWorkspace,
        breadCrumbs,
    },
    data: () => ({
        module_code: "",
        messageRoutes: [

            {
                path: "administration",
                name: "Administration Management"
            },
            {
                path: "inventory",
                name: "Inventory Management"
            },
            {
                path: "purchase",
                name: "Purchase Management"
            },
            {
                path: "project",
                name: "Project Management"
            },
            {
                path: "lc",
                name: "LC Management"
            },
            {
                path: "account",
                name: "Accounts Management"
            },
            {
                path: "bhp",
                name: "Buying House Production"
            },
            {
                path: "sales",
                name: "Sales Module Dashboard"
            },
            {
                path: "hrm",
                name: "Human Resource Management"
            },
            {
                path: "attendance",
                name: "Attendance Management"
            },
            {
                path:"leave",
                name:"Leave Management"
            },
            {
                path:"payroll",
                name: "Payroll Management"
            },
            {
                path: "employee-benefit-funds",
                name: "Employee Benefit Funds"
            },
            {
                path:"asset",
                name:"Asset Management"
            },
            {
                path:"documents",
                name:"Documentation Management"
            },
            {
                path:"task",
                name:"Task Management"
            },
            {
                path:"notification",
                name:"Notification Management"
            },
            {
                path:"master-data",
                name:"Master Data Management"
            },
            {
                path:"production",
                name:"Production Management"
            },
            {
                path:"prd",
                name:"Production Management"
            },
        ],
        componentMap : {
          "sales": defineAsyncComponent(() =>
              import('@/components/module/sales/saleDashboard.vue')
          ),
          "purchase": defineAsyncComponent(() =>
              import('@/components/module/purchase/purchaseDashboard.vue')
          ),
          "inventory": defineAsyncComponent(() =>
              import('@/components/module/inventory/inventoryDashboard.vue')
          ),
          "project": defineAsyncComponent(() =>
              import('@/components/module/project/projectDashboard.vue')
          ),
          "production": defineAsyncComponent(() => import('@/components/module/production/productionDashboard.vue')),
          "prd": defineAsyncComponent(() => import('@/components/module/production/productionDashboard.vue')),
          "attendance": defineAsyncComponent(() => import('@/components/module/smart/SmartModuleDashboard.vue')),
          "hrm": defineAsyncComponent(() => import('@/components/module/smart/SmartModuleDashboard.vue')),
          "account": defineAsyncComponent(() => import('@/components/module/smart/SmartModuleDashboard.vue')),
          "accounts": defineAsyncComponent(() => import('@/components/module/smart/SmartModuleDashboard.vue')),
          "asset": defineAsyncComponent(() => import('@/components/module/smart/SmartModuleDashboard.vue')),
          "assets": defineAsyncComponent(() => import('@/components/module/smart/SmartModuleDashboard.vue')),
          "payroll": defineAsyncComponent(() => import('@/components/module/smart/SmartModuleDashboard.vue')),
          "leave": defineAsyncComponent(() => import('@/components/module/smart/SmartModuleDashboard.vue')),
          "audit-log": defineAsyncComponent(() => import('@/components/module/smart/SmartModuleDashboard.vue')),
          "auditlog": defineAsyncComponent(() => import('@/components/module/smart/SmartModuleDashboard.vue')),
          "employee-benefit-funds": defineAsyncComponent(() => import('@/components/module/smart/SmartModuleDashboard.vue')),
          "master-data": defineAsyncComponent(() => import('@/components/module/smart/SmartModuleDashboard.vue')),
          "masterdata": defineAsyncComponent(() => import('@/components/module/smart/SmartModuleDashboard.vue')),
          "administration": defineAsyncComponent(() => import('@/components/module/smart/SmartModuleDashboard.vue')),
          "lc": defineAsyncComponent(() => import('@/components/module/smart/SmartModuleDashboard.vue')),
          "lc-management": defineAsyncComponent(() => import('@/components/module/smart/SmartModuleDashboard.vue')),
          "ebf": defineAsyncComponent(() => import('@/components/module/smart/SmartModuleDashboard.vue')),
          "customer-profile" : defineAsyncComponent(() =>
              import('@/views/module/customerProfile/CustomerProfileWorkspace.vue')
          ),
        }
    }),
    watch: {
    },
    created() {
    },
    computed: {
        isInventoryOrPurchaseDashboard() {
            return ["inventory", "purchase"].includes(this.$route.params.prefix);
        },
        isSmartDashboard() { return ["production", "prd", "attendance", "hrm", "account", "accounts", "asset", "assets", "payroll", "leave", "audit-log", "auditlog", "employee-benefit-funds", "ebf", "master-data", "masterdata", "administration", "lc", "lc-management"].includes(this.$route.params.prefix); },
        normalizedDashboardModule() {
            return ({account:'accounts',accounts:'accounts',assets:'asset',auditlog:'audit-log',ebf:'employee-benefit-funds',masterdata:'master-data','lc-management':'lc'})[this.$route.params.prefix] || this.$route.params.prefix;
        },
        getNavbarItemsFeatures() {
            var menu = JSON.parse(localStorage.getItem("menu"));
            var module_code = this.module_code;
            var data = menu.filter(function (el) {
                return el.code == module_code;
            });
            this.loading = true;
            return data;
        },
        /* moduleName() {
            const segments = this.$route.path.split("/");
            const module = segments[2].toLocaleLowerCase();
            const found = this.messageRoutes.find((item) => item.path === module);
            return found?.name;
        } */
       moduleName() {
            const module = this.$route.path.split("/")[2]?.toLowerCase();
            const found = this.messageRoutes.find(
                item => item.path === module
            );
            return found?.name ?? '';
        },
        currentComponent(){
          return this.componentMap[this.$route.params.prefix] || null
        }
    },
    methods: {
        goTo(val) {
            this.$router.push({ path: val }).catch(err => { });
        },
    },
    mounted() {
        this.module_code = this.$route.params.module_code;
        const array = this.$route.path.split("/")
    }
}
</script>
